/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface TaskCompteur {
    successes?: number;
    failures?: number;
    nbTotalLines?: number;
    rowsAttachedOnlyToDefaultPartner?: number;
    partnersAttachedOnlyToDefault?: Array<string>;
    date?: Date;
    /** Début de cette exécution (`date` en est la fin) ; absent pour les entrées antérieures à son introduction. */
    dateExec?: Date;
    /** Lignes passées à IMPORTED par cette exécution précisément (par opposition au cumul de `successes`) ; absent si non calculé. */
    newSuccesses?: number;
    /** Lignes passées à ERROR par cette exécution précisément (par opposition au cumul de `failures`) ; absent si non calculé. */
    newFailures?: number;
}